import { accountMessagesStyles } from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(accountMessagesStyles, {
    ...accountMessagesStyles,
    messagesAccordion: {
        css: css`
            width: 100%;
            dt[data-test-selector="sectionHeader"] {
                button {
                    background: #708090;
                    border: 1px solid #708090;
                    span {
                        color: #fff;
                        font-weight: 600;
                    }
                }
                button[aria-expanded="true"] {
                    background: #fff;
                    border-color: #d5d5d5;
                    span {
                        color: #708090;
                    }
                }
            }
        `,
    },
    messageCardGridItem: {
        width: 12,
        css: css`
            padding: 7.5px 0;
        `,
    },
    messageCard: {
        gridContainer: { gap: 5 },
        article: {
            css: css`
                width: 100%;
                > div {
                    background: #f5f5f5;
                    border: 1px solid #d4d4d4;
                    padding: 15px;
                }
            `,
        },
        dateTimeGridItem: { width: 12 },
        dateTimeText: {
            weight: "bold",
            css: css`
                font-size: 13px;
                font-style: italic;
            `,
        },
        subjectGridItem: { width: 12 },
        subjectText: { weight: "bold" },
        bodyGridItem: { width: 6 },
        bodyText: { weight: "bold" },
        actionButtonGridItem: {
            width: 6,
            css: css`
                justify-content: flex-end;
            `,
        },
        actionButton: {
            css: css`
                background-color: #999;
                border: none;
                padding: 11px;
                :hover {
                    background-color: #999;
                }
                span {
                    text-transform: none;
                }
            `,
        },
        bottomBorderGridItem: {
            width: 12,
            css: css`
                display: none;
            `,
        },
        bottomBorder: {
            css: css`
                display: none;
            `,
        },
    },
});
